const translations = {
  areYouSure: 'Are you sure?',
  cancel: 'Cancel',
  ok: 'OK',
};

export default translations;
